import React, { useRef, useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import './About.css';

export default function AboutSection() {
  const sectionRef = useRef(null);
  const [animateFeatures, setAnimateFeatures] = useState(false);

  useEffect(() => {
    // Function to check if element is in viewport
    const isInViewport = (element) => {
      const rect = element.getBoundingClientRect();
      return (
        rect.top <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.bottom >= 0
      );
    };

    // Function to handle scroll and animate section
    const handleScroll = () => {
      if (sectionRef.current && isInViewport(sectionRef.current)) {
        // Add animation class to section
        sectionRef.current.classList.add('animate-section');

        // Trigger feature animations with delay
        setTimeout(() => {
          setAnimateFeatures(true);
        }, 500);

        // Remove scroll listener once triggered
        window.removeEventListener('scroll', handleScroll);
      }
    };

    // Add scroll listener
    window.addEventListener('scroll', handleScroll);

    // Check on initial load
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <section className="about-section" id="about">
      <Container>
        <div className="about-container" ref={sectionRef}>
          <div className="about-header">
            <h2 className="about-title">MCGPChain</h2>
            <div className="about-title-underline"></div>
          </div>

          <div className="about-content">
            <p className="about-description">
              MCGPChain is a community-driven platform focused on
              decentralization, transparency, and the adoption of Web3 and AI
              technologies. Our mission is to bridge traditional finance with
              the digital economy by making it easy to tokenize real-world
              assets (RWAs) such as real estate, agriculture, and securities. We
              aim to empower global users with secure, compliant, and accessible
              investment tools, aligned with the projected $16 trillion RWA
              tokenization market by 2030.
            </p>

            <div className="highlight-box">
              <h3 className="highlight-title">
                The $16 Trillion Tokenization Revolution Awaits
              </h3>
              <p className="highlight-description">
                Enter the future of finance - seamlessly transform your
                real-world assets into tokenized assets with MCGPChain.
              </p>
            </div>
          </div>

          <Row className="features-container">
            <Col lg="4" md="6" sm="12" className="feature-column">
              <div
                className={`feature-card ${
                  animateFeatures ? 'animate-feature-1' : ''
                }`}
              >
                <div className="feature-icon-wrapper">
                  <div className="feature-icon interactive-icon">
                    <span>🔐</span>
                  </div>
                </div>
                <h3 className="feature-title">Secure</h3>
                <p className="feature-description">
                  Built on robust blockchain technology with multi-layer
                  security protocols to protect all assets and transactions
                </p>
              </div>
            </Col>

            <Col lg="4" md="6" sm="12" className="feature-column">
              <div
                className={`feature-card ${
                  animateFeatures ? 'animate-feature-2' : ''
                }`}
              >
                <div className="feature-icon-wrapper">
                  <div className="feature-icon interactive-icon">
                    <span>🌎</span>
                  </div>
                </div>
                <h3 className="feature-title">Accessible</h3>
                <p className="feature-description">
                  Lowering barriers to investment through fractional ownership,
                  making high-value assets available to everyone
                </p>
              </div>
            </Col>

            <Col lg="4" md="6" sm="12" className="feature-column">
              <div
                className={`feature-card ${
                  animateFeatures ? 'animate-feature-3' : ''
                }`}
              >
                <div className="feature-icon-wrapper">
                  <div className="feature-icon interactive-icon">
                    <span>🔄</span>
                  </div>
                </div>
                <h3 className="feature-title">Impactful</h3>
                <p className="feature-description">
                  Creating real-world value through blockchain solutions that
                  address actual market needs and inefficiencies
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}
